/* Fransk katalog for locale-inbox-vouchers-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'voucher.none': 'Aucun justificatif',
  'voucher.noLedgerLines': 'Aucune ligne du grand livre disponible depuis le backend pour le moment.',
  'voucher.noLedger': 'Aucune ligne du grand livre',
  'voucher.action': 'Action',
  'voucher.title': 'Transactions',
  'voucher.incompleteBasis': 'La couverture du journal est incomplète. La liste peut servir à rechercher des documents, mais ne doit pas être lue comme un grand livre ou une liste de justificatifs complète.',
  'voucher.subtitle': 'Toutes les transactions comptabilisées de l\'exercice',
  'voucher.backToVat': 'Retour à la MVA-melding',
  'voucher.showAll': 'Afficher toutes les transactions',
  'voucher.download': 'Télécharger',
  'voucher.loadingPreview': 'Chargement de l\'aperçu...',
  'voucher.cannotPreviewUse': 'Le fichier ne peut pas être prévisualisé ici. Utilisez « Télécharger » pour l\'ouvrir.',
  'voucher.cannotPreview': 'Ce type de fichier ne peut pas être prévisualisé ici.',
  'voucher.invoice': 'Facture',
  'voucher.voucher': 'Justificatif',
  'voucher.attachmentAttached': 'Justificatif joint',
  'voucher.commentOptional': 'Commentaire (facultatif)',
  'voucher.commentPh': 'Ex. : montant erroné, écriture en double ou mauvais fournisseur.',
  'voucher.view': 'Affichage',
  'voucher.viewHelp': 'Basculez entre la liste des justificatifs, les écritures détaillées et le grand livre regroupé par compte.',
  'voucher.view.bilag': 'Justificatifs',
  'voucher.view.detaljer': 'Détails',
  'voucher.view.hovedbok': 'Grand livre',
  'voucher.searchPh': 'Rechercher par justificatif, compte ou montant',
  'voucher.searchHelp': 'Recherchez par numéro de justificatif, contrepartie, compte/écriture ou montant. Dans le grand livre, vous pouvez aussi rechercher par débit, crédit et solde.',
  'voucher.filterHelp': 'Filtrez les justificatifs par type, pièce jointe, statut de paiement, période et montant.',
  'voucher.amountTitle': 'Montant du justificatif',
  'voucher.amountHelp': 'Le HT est le montant hors TVA (la charge ou le produit lui-même), la TVA est la taxe, et le TTC est le montant total TVA comprise. Avec la date et le numéro de justificatif, ce sont les informations clés de l\'écriture.',
  'voucher.rowHelp': 'Chaque ligne correspond à un justificatif. L\'icône et l\'étiquette indiquent le type (vente, achat, facture fournisseur, avoir, justificatif manuel), avec le nom et le numéro de justificatif. Appuyez sur la ligne pour ouvrir le justificatif.',
  'voucher.net': 'HT',
  'voucher.netHelp': 'Le montant hors TVA - la charge ou le produit lui-même, comptabilisé sur un compte.',
  'voucher.vat': 'TVA',
  'voucher.vatHelp': 'La TVA du justificatif - TVA collectée sur les ventes, TVA déductible sur les achats.',
  'voucher.gross': 'TTC',
  'voucher.grossHelp': 'Le montant total TVA comprise - HT plus TVA. C\'est le montant effectivement payé ou reçu.',
  'voucher.accountPh': 'Ex. : logiciel, banque ou 6300',
  'voucher.account': 'Compte',
  'voucher.accountHelp': 'Le compte indique l\'objet de l\'écriture - issu du plan comptable. Le numéro de compte détermine où le montant apparaît dans la comptabilité (1xxx actifs, 2xxx dettes/capitaux propres, 3xxx produits, 4-7xxx charges). Appuyez sur l\'icône de liste pour rechercher dans le plan comptable.',
  'voucher.pickAccount': 'Choisir un compte',
  'voucher.searchChart': 'Rechercher dans le plan comptable...',
  'voucher.noDescription': 'Sans description',
  'voucher.removeEntry': 'Supprimer l\'écriture',
  'voucher.entryDate': 'Date du justificatif',
  'voucher.entryDateHelp': 'La date à laquelle l\'écriture doit être comptabilisée. Elle détermine la période comptable et la période de TVA de l\'écriture.',
  'voucher.whatFor': 'Quel est l\'objet de l\'écriture ?',
  'voucher.whatForHelp': 'Un court texte expliquant l\'objet de l\'écriture. Il apparaît dans le grand livre et facilite la compréhension de l\'écriture par la suite.',
  'voucher.fromAccount': 'Compte de départ',
  'voucher.toAccount': 'Compte de destination',
  'voucher.fromAccountCredit': 'Compte de départ (crédit)',
  'voucher.fromAccountHelp': 'Le compte D\'OÙ provient l\'argent - le côté crédit de l\'écriture. Si vous payez par exemple le loyer depuis le compte bancaire, la banque (1920) est « De ». Un crédit diminue un actif ou augmente une dette/un produit.',
  'voucher.vatCode': 'Code TVA',
  'voucher.vatCodeHelp': 'Le code de taxe détermine le calcul de la TVA et sa déclaration dans la MVA-melding. Le code 86 est utilisé pour les services fournis à distance depuis l\'étranger. Les importations de marchandises sont enregistrées via la déclaration en douane.',
  'voucher.swap': 'Inverser De et Vers',
  'voucher.swapHelp': 'Inverse les comptes De et Vers de la ligne. Utile si vous avez saisi le débit et le crédit à l\'envers.',
  'voucher.toAccountDebit': 'Compte de destination (débit)',
  'voucher.toAccountHelp': 'Le compte VERS lequel va l\'argent - le côté débit de l\'écriture. S\'il s\'agit du loyer, le compte de loyer (6300) est « Vers ». Un débit augmente une charge ou un actif.',
  'voucher.addLineHelp': 'Ajoute une nouvelle ligne à cette écriture. Utilisez plusieurs lignes lorsque le montant doit être réparti sur plusieurs comptes - l\'ensemble des lignes doit équilibrer débit et crédit à zéro.',
  'voucher.attachHelp': 'Joignez une documentation à l\'écriture - reçu, facture ou autre justificatif. Facultatif mais recommandé : une bonne documentation rend la comptabilité vérifiable. Vous pouvez glisser des fichiers ou coller une capture d\'écran.',
  'voucher.attachOptional': 'Pièces jointes (facultatif)',
  'voucher.uploadAttachment': 'Téléverser une pièce jointe',
  'voucher.deleteAttachment': 'Supprimer la pièce jointe',
  'voucher.openNewTab': 'Ouvrir dans un nouvel onglet',
  'voucher.balance': 'Équilibre',
  'voucher.balanceHelp': 'Indique si l\'écriture est équilibrée. « Équilibrée » signifie que le total Vers (débit) est égal au total De (crédit) - l\'écriture peut alors être enregistrée. En cas d\'écart, corrigez les montants pour qu\'ils s\'équilibrent à zéro.',
  'voucher.toDebit': 'Vers (débit)',
  'voucher.fromCredit': 'De (crédit)',
  'voucher.posted': 'Comptabilisé',
  'voucher.edit': 'Modifier',
  'voucher.newCopy': 'Nouvelle copie de l\'écriture libre',
  'voucher.newFree': 'Nouvelle écriture libre',
  'voucher.from': 'De',
  'voucher.to': 'Vers',
  'voucher.sum': 'Total',
  'voucher.newEntry': 'Nouvelle écriture',
  'voucher.newEntryHelp': 'Ajoute une autre écriture (un nouveau justificatif) dans le même enregistrement. Chaque écriture a sa propre date, sa description et ses lignes, et est comptabilisée comme un justificatif distinct.',
  'voucher.postHelp': 'Comptabilise la ou les écritures. Le bouton n\'est actif que lorsque toutes les écritures sont équilibrées - c\'est-à-dire que débit et crédit s\'équilibrent à zéro.',
  'voucher.details': 'Détails',
  'voucher.statusBalanced': 'Équilibrée',
  'voucher.statusMissingAccount': 'Compte manquant',
  'voucher.statusSameAccount': 'Même compte',
  'voucher.statusEmpty': 'Vide',
  'voucher.statusUnbalanced': 'Déséquilibrée',
  'voucher.attachDropHint': 'Glissez-déposez des fichiers ici ou collez une capture d\'écran avec Ctrl+V',
  'voucher.chooseBothAccounts': 'Choisissez le compte de départ et le compte de destination.',
  'voucher.sameAccountWarning': 'Le compte de départ et le compte de destination ne peuvent pas être identiques.',
  'voucher.balancedReady': 'Équilibrée - prête à être enregistrée',
  'voucher.enterAmount': 'Saisissez un montant.',
  'voucher.difference': 'Écart : {amount}',
  'voucher.postedTitlePlural': 'Écritures enregistrées',
  'voucher.postedTitleSingular': 'Écriture enregistrée',
  'voucher.postedBodyPlural': '{count} écritures ont été comptabilisées.',
  'voucher.postedBodySingular': 'L\'écriture a été comptabilisée.',
  'voucher.postedIntro': 'Voici comment elle a été comptabilisée :',
  'voucher.descriptionRequired': 'Saisissez une description pour toutes les écritures avant de comptabiliser.',
  'voucher.saveFailed': 'Impossible d\'enregistrer l\'écriture.',
  'voucher.backTo': 'Retour à {label}',
  'voucher.controlPoint': 'point de contrôle',
  'voucher.editTitle': 'Modifier l\'écriture libre',
  'voucher.freePosting': 'Écriture libre',
  'voucher.editSubtitle': 'Mettez à jour l\'écriture et enregistrez les modifications dans le backend.',
  'voucher.correctPostedTitle': 'Corriger un justificatif comptabilisé',
  'voucher.correctPostedSubtitle': 'L\'original est conservé. Plumme comptabilise une contrepassation et un nouveau justificatif de remplacement en une seule opération.',
  'voucher.correctPostedNotice': 'Le justificatif d\'origine et le numéro de journal ne sont pas modifiés. La modification est enregistrée comme une contre-passation liée suivie d\'un remplacement.',
  'voucher.correctionReason': 'Motif de la correction',
  'voucher.correctionReasonPlaceholder': 'Décrivez ce qui était erroné et pourquoi le justificatif est corrigé',
  'voucher.correctPostedAction': 'Corriger le justificatif',
  'voucher.correctionPreview': 'Aperçu de la correction',
  'voucher.correctionOriginal': 'Original',
  'voucher.correctionReversal': 'Contre-passation exacte',
  'voucher.correctionReplacement': 'Justificatif de remplacement',
  'voucher.freePostingSubtitle': 'Écritures manuelles - le débit et le crédit doivent s\'équilibrer à zéro',
  'voucher.freePostingTitleHelp': 'L\'écriture libre vous permet de comptabiliser manuellement directement sur un compte lorsque vous avez besoin d\'un contrôle total - par exemple pour des corrections, des reclassements ou des écritures qui ne correspondent pas à un achat ou une vente ordinaire. Vous choisissez vous-même entre quels comptes le montant est transféré.',
  'voucher.directVatWarningTitle': 'Avertissement : écriture directe sur un compte de TVA',
  'voucher.directVatWarningBody': 'Ces écritures sont comptabilisées dans le grand livre, mais ne sont pas reprises dans la MVA-melding. Utilisez l\'achat, la vente ou la déclaration en douane ordinaire lorsque le montant doit être déclaré en TVA.',
  'voucher.directVatExcluded': 'non repris dans la MVA-melding',
  'voucher.directVatConfirmLabel': 'Saisissez OK pour confirmer que vous comprenez la conséquence',
  'voucher.directVatConfirmValue': 'OK',
  'voucher.registerEntriesPlural': 'Enregistrer les écritures',
  'voucher.registerEntrySingular': 'Enregistrer l\'écriture',
  'voucher.registering': 'Enregistrement...',
  'voucher.creditWord': 'crédit',
  'voucher.debitWord': 'débit',
  'voucher.attachmentFallbackName': 'piece-jointe',
  'inbox.prevPage': 'Page précédente',
  'inbox.page': 'Page',
  'inbox.nextPage': 'Page suivante',
  'inbox.zoomOut': 'Zoom arrière',
  'inbox.zoomIn': 'Zoom avant',
  'inbox.rotate': 'Faire pivoter le justificatif',
  'inbox.mainDoc': 'Justificatif principal',
  'inbox.moveTo': 'Déplacer vers',
  'inbox.payOperating': 'Compte courant - 1920',
  'inbox.payCash': 'Espèces - 1900',
  'inbox.payPrivate': 'Avance personnelle',
  'inbox.payUnknown': 'Choisir la source de paiement ...',
  'inbox.suggestion': 'Suggestion de SuperPlumma',
  'inbox.docType': 'Type de justificatif',
  'inbox.quickChoices': 'Choix rapides',
  'inbox.quickChoiceUse': 'Choisissez ce que le choix rapide doit remplacer',
  'inbox.quickChoiceRemembered': 'Mémorisé à partir de justificatifs précédents de ce fournisseur ({count}).',
  'inbox.quickChoiceAccount': 'Remplacer le compte',
  'inbox.quickChoiceDescription': 'Remplacer la description',
  'inbox.quickChoiceBoth': 'Remplacer les deux',
  'inbox.purchase': 'Achat',
  'inbox.supplierInvoice': 'Facture fournisseur',
  'inbox.pickSupplier': 'Choisir un fournisseur',
  'inbox.invoiceNoPh': 'Ex. 0012345',
  'inbox.toggleVatHelp': 'Appuyez pour indiquer si le montant saisi est hors TVA ou TTC. Plumme convertit automatiquement et enregistre le montant brut dans la proposition de justificatif.',
  'inbox.vatDeductionRate': 'Déduction de TVA proposée',
  'inbox.documentVatRateHint': 'Le justificatif indique {documentRate} % de TVA. La proposition applique une déduction de {deductionRate} % selon le statut TVA de l\'entreprise et le traitement choisi.',
  'inbox.accountCategory': 'Compte/catégorie',
  'inbox.accountHelp': 'La suggestion de SuperPlumma est présélectionnée. Appuyez pour choisir un autre compte.',
  'inbox.dueDateFromReceipt': 'Le justificatif n\'a pas de date d\'échéance. Elle a été fixée à la date du justificatif.',
  'inbox.supplierNotSaved': 'Sélectionnez un fournisseur enregistré ou enregistrez le fournisseur avant de comptabiliser la facture.',
  'err.purchase.supplierNotSaved': 'Sélectionnez un fournisseur enregistré ou enregistrez le fournisseur avant de comptabiliser la facture.',
  'inbox.duplicateTitle': 'Doublon possible',
  'inbox.duplicateBody': 'Un justificatif avec la même date et le même montant est déjà comptabilisé.',
  'inbox.duplicateSameSupplier': 'Un justificatif avec la même date, le même montant et le même fournisseur est déjà comptabilisé.',
  'inbox.duplicateUploadFile': 'Import en double possible : exactement le même fichier se trouve déjà dans la boîte de réception.',
  'inbox.duplicateUploadContent': 'Import en double possible : même fournisseur et même montant qu\'un autre justificatif de la boîte de réception, avec des dates à moins de 7 jours d\'écart.',
  'inbox.duplicateUploadCount': 'Concerne d\'autres justificatifs : {count}.',
  'inbox.setPaymentSource': 'Payé depuis',
  'inbox.bulkPaymentTitle': 'Payé depuis',
  'inbox.bulkPaymentLead': 'La source est appliquée à {count} justificatifs. Vous pourrez ensuite la modifier pour chaque justificatif.',
  'inbox.bulkPaymentLabel': 'Payé depuis',
  'inbox.bulkPaymentHint': 'Les justificatifs seront prêts à être comptabilisés avec ce compte.',
  'inbox.bulkPaymentPick': 'Choisissez d\'abord une source de paiement.',
  'inbox.bulkPaymentConfirm': 'Appliquer à {count} justificatifs',
  'inbox.bulkPaymentDone': 'Source de paiement appliquée à {count} justificatifs.',
  'inbox.uploadPaymentSingleTitle': 'Payé depuis',
  'inbox.uploadPaymentBulkTitle': 'Attribuer les sources de paiement',
  'inbox.uploadPaymentAppliesTo': 'S\'applique à {count} justificatifs sélectionnés',
  'inbox.uploadPaymentSelectFirst': 'Sélectionnez les justificatifs ci-dessous, puis les boutons définiront leur source de paiement.',
  'inbox.uploadPaymentBank': 'Banque',
  'inbox.uploadPaymentBankSetup': 'Ajoutez d\'abord un compte bancaire',
  'inbox.uploadPaymentOtherSource': 'Choisir une autre source de paiement ...',
  'inbox.uploadPaymentOperating': 'Compte courant',
  'inbox.uploadPaymentPrivate': 'Personnel',
  'inbox.uploadPaymentPrivateRecommended': 'Recommandé sans compte professionnel',
  'inbox.uploadPaymentAnalyzeShort': 'Superplumma analyse',
  'inbox.collectionNotice': 'Avis de recouvrement',
  'inbox.collectionNoticeTitle': 'Ceci se rattache au justificatif d\'origine',
  'inbox.collectionNoticeBody': 'La créance principale ne doit pas être comptabilisée ni soumise à la TVA une seconde fois. Liez l\'avis au justificatif d\'origine ; les intérêts et frais de recouvrement sont traités séparément sans TVA.',
  'inbox.collectionNoticePrincipal': 'Créance principale',
  'inbox.collectionNoticeInterest': 'Intérêts',
  'inbox.collectionNoticeCosts': 'Frais de recouvrement',
  'inbox.collectionNoticeCandidates': 'Justificatifs d\'origine possibles',
  'inbox.collectionNoticeLink': 'Lier',
  'inbox.collectionNoticeLinked': 'L\'avis de recouvrement est lié au justificatif d\'origine.',
  'inbox.collectionNoticeLinkFailed': 'Impossible de lier l\'avis de recouvrement au justificatif d\'origine.',
  'inbox.collectionNoticeOpenOriginal': 'Ouvrir le justificatif d\'origine',
  'inbox.collectionNoticeNoCandidate': 'Aucune correspondance fiable trouvée. Retrouvez ou importez la facture d\'origine avant de traiter l\'avis.',
  'inbox.collectionNoticeBookBlocked': 'Liez au justificatif d\'origine avant le traitement',
  'inbox.uploadPaymentAssigned': 'Compte {account}',
  'inbox.uploadPaymentUnpaid': 'Pas encore payé',
  'inbox.uploadPaymentUnpaidHint': 'Pour une facture fournisseur qui doit rester en dette jusqu\'à son paiement.',
  'inbox.uploadPaymentAnalyze': 'Laisser Plumme trouver la source de paiement',
  'inbox.uploadPaymentUnassigned': 'Non attribué',
  'inbox.uploadPaymentSelectVisible': 'Sélectionner les éléments affichés',
  'inbox.uploadPaymentShowAll': 'Tout afficher',
  'inbox.uploadPaymentShowPending': 'Afficher uniquement les non attribués',
  'inbox.uploadPaymentProgress': '{completed} sur {count} attribués',
  'inbox.uploadPaymentConfirm': 'Importer {count}',
  'inbox.uploadPaymentReceipt': 'Justificatif',
  'inbox.cardNudgeTitle': 'Justificatifs sans source de paiement : {count}',
  'inbox.cardNudgeText': 'Enregistrez vos cartes sur les comptes bancaires et Plumme reconnaîtra le paiement directement à partir du reçu. Le type de compte détermine si l\'achat est professionnel ou une avance personnelle.',
  'inbox.cardNudgeAction': 'Enregistrer les cartes',
  'inbox.shortDescription': 'Brève description du justificatif',
  'inbox.shrinkPreview': 'Réduire l\'aperçu',
  'inbox.growPreview': 'Agrandir l\'aperçu',
  'inbox.dragWidth': 'Faites glisser pour modifier la largeur',
  'inbox.sendTo': 'Envoyer vers :',
  'inbox.filterStatus': 'Statut',
  'inbox.filterBankConnection': 'Connexion bancaire',
  'inbox.filterReadyToPost': 'Prêt à comptabiliser',
  'inbox.filterNeedsReview': 'À vérifier',
  'inbox.filterAwaitingAnalysis': 'En attente d\'analyse',
  'inbox.toInbox': 'Vers la boîte de réception (justificatifs)',
  'inbox.toDocumentation': 'Vers la documentation',
  'inbox.selectAll': 'Tout sélectionner',
  'inbox.selectHint': 'Maj-clic pour sélectionner une plage',
  'inbox.reviewSelected': 'Commencer la saisie ({count})',
  'inbox.planTitle': 'Comptabiliser avec SuperPlumma',
  'inbox.planLead': '{count} des {selected} justificatifs sélectionnés seront comptabilisés maintenant.',
  'inbox.planNothing': 'Aucun des justificatifs sélectionnés ne peut être comptabilisé en l\'état.',
  'inbox.planWithNotes': '{count} avec une source de paiement présélectionnée',
  'inbox.planConfirm': 'Comptabiliser {count} justificatifs',
  'inbox.planShow': 'Afficher',
  'inbox.planHide': 'Masquer',
  'inbox.planSameFile': 'Bloqué : exactement le même fichier est déjà présent ({count})',
  'inbox.planSameInvoiceNumber': 'Bloqué : le numéro de facture est déjà enregistré ({count})',
  'inbox.planSameContent': 'Ignoré : import en double possible ({count})',
  'inbox.planNeedsReview': 'Ignoré : vérification requise ({count})',
  'inbox.planMissingData': 'Ignoré : données manquantes ({count})',
  'inbox.planMissing': 'Ignoré : n\'existe plus ({count})',
  'inbox.planAllowContent': 'Comptabiliser quand même - j\'ai vérifié qu\'il s\'agit d\'achats distincts',
  'inbox.planAllowContentWarn': 'Les doublons seront comptabilisés comme justificatifs distincts. Vérifiez que c\'est correct avant de continuer.',
  'inbox.planResultTitle': 'Comptabilisation terminée',
  'inbox.planResultLead': '{booked} des {selected} justificatifs sélectionnés ont été comptabilisés.',
  'inbox.planBooked': 'Comptabilisés ({count})',
  'inbox.planSkipped': 'Ignorés ({count})',
  'inbox.planFailed': 'En échec ({count})',
  'inbox.walkTitle': 'Saisie des justificatifs',
  'inbox.walkLead': 'Justificatifs dans la file : {count}.',
  'inbox.walkReady': 'Prêts',
  'inbox.walkNeedsReview': 'À vérifier',
  'inbox.walkDuplicates': 'Doublons possibles',
  'inbox.walkDuplicateOf': 'Identique à {names}.',
  'inbox.walkHint': 'Vous pouvez fermer à tout moment - ce que vous n\'avez pas traité reste sélectionné.',
  'inbox.walkStart': 'Parcourir les {count}',
  'inbox.walkBookReady': 'Comptabiliser maintenant les {count} prêts',
  'inbox.walkPosition': '{index} sur {total}',
  'inbox.walkPause': 'Continuer plus tard',
  'inbox.walkTrash': 'À la corbeille',
  'inbox.walkSkip': 'Ignorer',
  'inbox.walkNext': 'Suivant',
  'inbox.walkGone': 'Le justificatif n\'existe plus',
  'inbox.walkGoneText': 'Il a été comptabilisé, supprimé ou déplacé pendant que l\'examen était ouvert.',
  'inbox.walkDoneTitle': 'Examen terminé',
  'inbox.walkDoneLead': 'Justificatifs examinés : {count}',
  'inbox.walkDoneCounts': '{booked} comptabilisés, {skipped} ignorés, {trashed} déplacés dans la corbeille.',
  'inbox.clearSelection': 'Effacer la sélection',
  'inbox.restoreAll': 'Tout restaurer',
  'inbox.deletePermanently': 'Supprimer définitivement',
  'inbox.deleteAll': 'Tout supprimer',
  'inbox.downloadAll': 'Télécharger la sélection',
  'inbox.downloading': 'Téléchargement...',
  'inbox.postAllWithAi': 'Tout comptabiliser avec SuperPlumma',
  'inbox.postWithAi': 'Comptabiliser {count} avec SuperPlumma',
  'inbox.postNoneReady': 'Aucun des justificatifs sélectionnés n\'est prêt à être comptabilisé. Utilisez « Commencer la saisie » pour les traiter un par un.',
  'inbox.uploadDocument': 'Téléverser un document',
  'inbox.mergeToOne': 'Fusionner en un seul justificatif',
  'inbox.dragToMerge': 'Faites glisser pour fusionner des justificatifs',
  'inbox.restore': 'Restaurer',
  'inbox.post': 'Comptabiliser',
  'inbox.archiveNote': 'Archive pour les documents qui ne doivent pas être comptabilisés comme justificatifs.',
  'inbox.searchDocs': 'Rechercher des documents...',
  'inbox.moveToTrash': 'Déplacer vers la corbeille',
  'inbox.defaultVoucherName': 'Justificatif',
  'inbox.defaultDocumentName': 'Document',
  'inbox.docTypeSettlement': 'Règlement',
  'inbox.docTypeSupplierInvoice': 'Facture fournisseur',
  'inbox.docTypeSaleVoucher': 'Justificatif de vente',
  'inbox.docTypePurchaseVoucher': 'Justificatif d\'achat',
  'inbox.paySourcePrivate': 'Payé à titre privé',
  'inbox.paySourceCash': 'Espèces',
  'inbox.paySourceUnclear': 'Paiement non clarifié',
  'inbox.paySourceCompany': 'Compte de l\'entreprise',
  'inbox.vatOnDocumentWithDeduction': '{documentRate} % de TVA sur le justificatif · {deductionRate} % de déduction',
  'inbox.vatRateLabel': '{rate} % de TVA',
  'inbox.paidFromBank': 'Payé depuis la banque',
  'inbox.supplierNotRead': 'Entreprise non lue',
  'inbox.invoiceNumberLabel': 'Facture {number}',
  'inbox.attachmentLinkMissing': 'La pièce jointe n\'a pas de lien disponible.',
  'inbox.menuNewPurchase': 'Achat payé',
  'inbox.menuFixedAsset': 'Immobilisation',
  'inbox.menuOtherSale': 'Autre vente',
  'inbox.menuOpenAttachment': 'Ouvrir la pièce jointe',
  'inbox.menuDownload': 'Télécharger',
  'inbox.menuSplitAgain': 'Rediviser',
  'inbox.reanalyze': 'Réanalyser',
  'inbox.analyze': 'Analyser',
  'inbox.previewDocumentFallback': 'Document',
  'inbox.previewMissingFileLink': 'Lien de fichier manquant',
  'inbox.saveNotConnected': 'L\'enregistrement des propositions de justificatif n\'est pas connecté au backend.',
  'inbox.suggestionUpdated': 'La proposition de justificatif a été mise à jour.',
  'inbox.suggestionSaveFailed': 'Impossible d\'enregistrer la proposition de justificatif.',
  'inbox.settlementFromLabel': 'Règlement de',
  'inbox.settlementFromPh': 'Vipps, Stripe, Klarna ...',
  'inbox.settlementIdLabel': 'ID du règlement',
  'inbox.settlementNetToBankLabel': 'Net versé en banque',
  'inbox.suggestedInvoiceSingular': 'Facture proposée',
  'inbox.suggestedInvoicePlural': 'Plusieurs factures possibles',
  'inbox.selectInvoiceManually': 'Choisir la facture manuellement',
  'inbox.paidToggleOn': 'Payé',
  'inbox.paidToggleOff': 'Non payé – comptabilisé en dettes fournisseurs',
  'inbox.paidToLabel': 'Payé à',
  'inbox.projectSaveFailed': 'Impossible d\'enregistrer le projet.',
  'inbox.awaitingOcrData': 'En attente des données OCR',
  'inbox.showSuggestionAgain': 'Réafficher la proposition',
  'inbox.maximizePreview': 'Agrandir l\'aperçu',
  'inbox.uploadPartialAnalyzing': '{done} justificatifs sur {total} ont été téléversés. Analyse de ceux reçus ...',
  'inbox.uploadedSingle': 'Justificatif téléversé.',
  'inbox.uploadedMultipleAnalyzing': 'Justificatifs téléversés : {count}. Analyse en cours ...',
  'inbox.uploadFailedSingle': 'Impossible de téléverser le justificatif.',
  'inbox.uploadFailedMultiple': 'Impossible de téléverser les justificatifs.',
  'inbox.uploadFailedGeneric': 'Impossible de téléverser des justificatifs.',
  'inbox.remainingAwaitingAnalysisSuffix': '{count} justificatifs restent « En attente d\'analyse ».',
  'inbox.uploadedButAnalysisFailedSingle': 'Le justificatif a été téléversé, mais l\'analyse a échoué.',
  'inbox.uploadedButAnalysisFailedMultiple': 'Les justificatifs ont été téléversés, mais l\'analyse a échoué.',
  'inbox.partialAnalysisFailed': '{failed} justificatifs sur {total} n\'ont pas été analysés. Essayez « Analyser » sur la ligne.',
  'inbox.documentAddedSingle': 'Document ajouté à Documentation.',
  'inbox.documentAddedMultiple': 'Les documents ont été ajoutés à Documentation.',
  'inbox.documentUploadFailed': 'Impossible de téléverser le document.',
  'inbox.analyzed': 'Le justificatif a été analysé.',
  'inbox.analyzeActionFailed': 'L\'analyse du justificatif a échoué.',
  'inbox.bookedNoneReason': 'Aucun justificatif n\'a été comptabilisé.',
  'inbox.bookedSummary': '{booked} comptabilisés, {skipped} ignorés.',
  'inbox.bookedOne': 'Le justificatif a été comptabilisé.',
  'inbox.bookedCount': 'Justificatifs comptabilisés : {count}.',
  'inbox.bookFailedFallback': 'Impossible de comptabiliser les justificatifs.',
  'inbox.setPaymentSourceFailed': 'Impossible de définir la source de paiement.',
  'inbox.moveToTrashFailed': 'Impossible de déplacer le justificatif.',
  'inbox.movedToTrash': 'Justificatif déplacé dans la corbeille.',
  'inbox.movedToTrashCount': 'Justificatifs déplacés dans la corbeille : {count}.',
  'inbox.restoredOne': 'Justificatif restauré.',
  'inbox.restoredCount': 'Justificatifs restaurés : {count}.',
  'inbox.restoreFailed': 'Impossible de restaurer le justificatif.',
  'inbox.confirmDeletePermanentOne': 'Supprimer définitivement le justificatif ?',
  'inbox.confirmDeletePermanentMany': 'Supprimer définitivement les justificatifs sélectionnés ?',
  'inbox.deletedPermanently': 'Justificatif supprimé définitivement.',
  'inbox.deleteFailed': 'Impossible de supprimer le justificatif.',
  'inbox.docMovedToTrash': 'Document déplacé dans la corbeille.',
  'inbox.docMovedToTrashCount': 'Documents déplacés dans la corbeille : {count}.',
  'inbox.docMoveToTrashFailed': 'Impossible de déplacer le document.',
  'inbox.docRestored': 'Document restauré.',
  'inbox.docRestoredCount': 'Documents restaurés : {count}.',
  'inbox.docRestoreFailed': 'Impossible de restaurer le document.',
  'inbox.confirmDeleteDocOne': 'Supprimer définitivement le document ?',
  'inbox.confirmDeleteDocMany': 'Supprimer définitivement les documents sélectionnés ?',
  'inbox.docDeletedPermanently': 'Document supprimé définitivement.',
  'inbox.docDeleteFailed': 'Impossible de supprimer le document.',
  'inbox.downloadPartial': '{downloaded} fichiers sur {total} ont été téléchargés. Les autres n\'ont pas pu être récupérés.',
  'inbox.downloadedZip': 'Fichiers téléchargés au format zip : {count}.',
  'inbox.downloadedSingleFile': 'Le fichier a été téléchargé.',
  'inbox.downloadFilesFailed': 'Impossible de télécharger les fichiers.',
  'inbox.movedToDocs': 'Justificatif déplacé vers Documentation.',
  'inbox.movedToDocsCount': 'Justificatifs déplacés vers Documentation : {count}.',
  'inbox.moveToDocsFailed': 'Impossible de déplacer le justificatif vers Documentation.',
  'inbox.mergedCount': 'Justificatifs fusionnés : {count}.',
  'inbox.mergeFailed': 'Impossible de fusionner les justificatifs.',
  'inbox.splitAgainDone': 'Le justificatif a été redivisé.',
  'inbox.splitAgainFailed': 'Impossible de diviser le justificatif.',
  'inbox.addressCopied': 'Adresse des justificatifs copiée.',
  'inbox.trashTitle': 'Corbeille',
  'inbox.docsSubtitle': 'Archive pour les accords, contrats et documents - pas des justificatifs à comptabiliser.',
  'inbox.inboxSubtitle': 'Téléversez ou transférez vos justificatifs par e-mail - nous lisons ce que nous pouvons.',
  'inbox.titleHelp': 'La boîte de réception rassemble les justificatifs reçus mais pas encore comptabilisés. Téléversez des fichiers ou transférez reçus et factures par e-mail - SuperPlumma lit le contenu et les prépare pour la comptabilisation.',
  'inbox.docsWithCount': 'Documentation ({count})',
  'inbox.trashWithCount': 'Corbeille ({count})',
});
